// extracted by mini-css-extract-plugin
export default {"loadsList":"LoadsList_loadsList__gv0oL","loadsList__switcher":"LoadsList_loadsList__switcher__Wb7W3"};